import classNames from "classnames";
import { forwardRef, InputHTMLAttributes, memo } from "react";

import { VALIDATION_CLASS } from "utils/constants";

export type TextInputPropsType = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string | boolean;
  hint?: string;
  variant?: "primary" | "secondary";
  afterIcon?: React.ReactNode;
  isDisabled?: boolean;
  isRequired?: boolean;
};

const TextInput = forwardRef(function TextInput(
  {
    value,
    id,
    label,
    error,
    hint,
    className,
    afterIcon,
    variant = "primary",
    isDisabled,
    isRequired,
    ...props
  }: TextInputPropsType,
  inputRef: React.Ref<HTMLInputElement>,
) {
  return (
    <div className={classNames("text-input", className, `text-input--${variant}`)}>
      <div
        className={classNames("text-input__field", {
          "text-input__field--filled": !!value,
          "text-input__field--error": !!error,
          [VALIDATION_CLASS]: !!error,
        })}
      >
        <input
          ref={inputRef}
          type="text"
          {...props}
          id={id}
          value={value ?? ""}
          className="text-input__input"
          disabled={isDisabled}
        />

        {afterIcon && <div className="text-input__after-icon">{afterIcon}</div>}

        {!!label && (
          <label
            htmlFor={id}
            className={classNames("text-input__label", {
              "text-input__label--required": isRequired,
            })}
          >
            {label}
          </label>
        )}
      </div>

      {!!error && typeof error === "string" && <div className="text-input__error">{error}</div>}
      {!!hint && !error && <div className="text-input__hint">{hint}</div>}
    </div>
  );
});

export default memo(TextInput);
